
export type BookingOwner = 'mine' | 'other';

export function classifyBookingOwner(
  agentUserId: string | null | undefined,
  viewerUserId: string | null | undefined,
): BookingOwner {
  return agentUserId != null && viewerUserId != null && agentUserId === viewerUserId
    ? 'mine'
    : 'other';
}

export function ownerCalendarTone(owner: BookingOwner): 'accent' | 'neutral' {
  return owner === 'mine' ? 'accent' : 'neutral';
}
